import { render, staticRenderFns } from "./PodsUsage.vue?vue&type=template&id=5c13d128&scoped=true&"
import script from "./PodsUsage.vue?vue&type=script&lang=js&"
export * from "./PodsUsage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c13d128",
  null
  
)

export default component.exports